// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"dd1d4ff8","551":"8115c3b9","828":"3c2467cf"}[chunkId] + ".chunk.js";
};